import { createContext, useContext, type ReactNode } from 'react'

/*
 * "One heartbeat per view" (design/system/07-motion.md, owner's decision 23.10, variant A):
 * at most one continuously animating element in view. When the header logo animates (On Air,
 * Connecting, Waiting), it is that element and every badge dot holds still; only where no state
 * logo is shown may the main ON AIR badge pulse. LIVE chips inside panels and the dots of output
 * rows never pulse (07-motion.md, BroadcastIndicator/README.md).
 *
 * Layout provides `logo` from the brand state; components ask useHeartbeat() before pulsing.
 * Reduced motion is handled in CSS (strevix-tokens.css, strevix-components.css).
 */

const Ctx = createContext({ logo: false })

export function Heartbeat({ logo, children }: { logo: boolean; children: ReactNode }) {
  return <Ctx.Provider value={{ logo }}>{children}</Ctx.Provider>
}

/** May the main ON AIR badge pulse here? Only when no animated logo is in view. */
export function useBadgePulse(): boolean {
  return !useContext(Ctx).logo
}
